export default __webpack_public_path__ + "static/media/trial-completed.6c174631.png";